import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { addNotification } from 'actions/globalActions';

import Button from 'components/common/Button';

import './styles.scss';

const CrawlersTableRowForm = ({ crawler, onSubmitForm }) => {
  const dispatch = useDispatch();

  // form values
  const [selectedName, setSelectedName] = useState(crawler.name);
  const [dnsNames, setDnsNames] = useState(crawler.dnsNames);
  const [newDnsName, setNewDnsName] = useState('');
  const [userAgentNames, setUserAgentNames] = useState(crawler.uaNames);
  const [newUserAgentName, setNewUserAgentName] = useState('');

  const handleNameChange = (e) => {
    const { value } = e.target;
    setSelectedName(value);
  };

  const validateName = (name) => {
    // only letters, numbers and whitespaces
    const nameRegEx = /^[A-Za-z0-9 ]+$/;
    if (!nameRegEx.test(name)) {
      return {
        type: 'warning',
        title: 'Invalid crawler name',
        description: 'Use only letters, numbers and spaces',
      };
    }
    return null;
  };

  const handleNewDnsName = (e) => {
    const { value } = e.target;
    setNewDnsName(value);
  };

  const handleAddDnsName = (e) => {
    e.preventDefault();
    const newName = [...dnsNames, newDnsName.trim()];
    console.log(newName);
    setDnsNames(newName);
    setNewDnsName('');
  };

  const handleRemoveDnsName = (index) => {
    console.log(index);
    dnsNames.splice(index, 1);
    setDnsNames([...dnsNames]);
  };

  const handleNewUserAgentName = (e) => {
    const { value } = e.target;
    setNewUserAgentName(value);
  };

  const handleAddUserAgentName = (e) => {
    e.preventDefault();
    const newName = [...userAgentNames, newUserAgentName.trim()];
    console.log(newName);
    setUserAgentNames(newName);
    setNewUserAgentName('');
  };

  const handleRemoveUserAgentName = (index) => {
    console.log(index);
    userAgentNames.splice(index, 1);
    setUserAgentNames([...userAgentNames]);
  };

  const submitForm = () => {
    const validationErrors = [validateName(selectedName)].filter(
      (e) => e !== null
    );
    if (validationErrors.length === 0) {
      onSubmitForm({
        name: selectedName,
        dnsNames: dnsNames,
        uaNames: userAgentNames,
      });
    } else {
      dispatch(addNotification(validationErrors[0]));
    }
  };

  return (
    <div className="control">
      <div className="field">
        <label className="label">Name</label>
        <input
          className="input"
          name="name"
          type="text"
          value={selectedName}
          onChange={handleNameChange}
        />
        <p className="help">Only letters, numbers and whitespaces allowed</p>
      </div>

      <div className="field">
        <label className="label">DNS Names</label>
        <form onSubmit={handleAddDnsName}>
          <input
            className="input"
            name="DNS name"
            type="text"
            value={newDnsName}
            onChange={handleNewDnsName}
          />
          <Button>Add Name</Button>
        </form>
        <div className="columns m-1">
          <div className="column">
            <ul>
              {dnsNames.map((item, index) => (
                <li key={index} className="mb-2">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="column">
            <ul>
              {dnsNames.map((item, index) => (
                <li key={index} className="mb-2">
                  <Button
                    size="small"
                    type="outlined"
                    rounded={true}
                    onClick={() => handleRemoveDnsName(index)}
                  >
                    X
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="field">
        <label className="label">User Agent Names</label>
        <form onSubmit={handleAddUserAgentName}>
          <input
            className="input"
            name="DNS name"
            type="text"
            value={newUserAgentName}
            onChange={handleNewUserAgentName}
          />
          <Button>Add Name</Button>
        </form>
        <div className="columns m-1">
          <div className="column">
            <ul>
              {userAgentNames.map((item, index) => (
                <li key={index} className="mb-2">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="column">
            <ul>
              {userAgentNames.map((item, index) => (
                <li key={index} className="mb-2">
                  <Button
                    size="small"
                    type="outlined"
                    rounded={true}
                    onClick={() => handleRemoveUserAgentName(index)}
                  >
                    X
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Button className="is-pulled-right" type="text" onClick={submitForm}>
        Save Changes
      </Button>
    </div>
  );
};

CrawlersTableRowForm.propTypes = {
  crawler: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    dnsNames: PropTypes.array,
    uaNames: PropTypes.array
  }),
  onSubmitForm: PropTypes.func,
};

export default CrawlersTableRowForm;
